import { useState, useEffect } from 'react'

/**
 * @deprecated Use **useDebouncedValue** from `@collaborate-health/uikit` instead.
 */
export default function useDebouncedValue(value, delay) {
  const [debouncedValue, setDebouncedValue] = useState(value)

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value)
    }, delay)

    return () => {
      clearTimeout(handler)
    }
  }, [delay, value])

  return debouncedValue
}
